var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.component ? _c('aside', {
    class: ['layer-component', {
      'layer-visible': _vm.open
    }],
    attrs: {
      "id": "layer-component"
    }
  }, [_c(_vm.component, {
    tag: "component",
    attrs: {
      "title": _vm.childTitle,
      "payload": _vm.payload
    },
    on: {
      "close": function close($event) {
        return _vm.closeLayer();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layer-overlay",
    on: {
      "click": function click($event) {
        return _vm.closeLayer();
      }
    }
  })], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };